var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ol',{staticClass:"breadcrumb breadcrumb-nav"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fal fa-home"})])],1),_vm._v(" "),_vm._l((_vm.ui.breadcrumbItems),function(item){return _c('li',{class:{
      group: !item.active,
      active: item.active,
    }},[_c('i',{staticClass:"fal fa-angle-right breadcrumb-icon"}),_vm._v(" "),_c('router-link',{staticClass:"bread-page-title",attrs:{"to":item.link}},[_vm._v(_vm._s(_vm._f("truncate")(_vm._f("stripHtml")(item.text))))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }